import { render, staticRenderFns } from "./MostContentCard.vue?vue&type=template&id=2946f729&"
import script from "./MostContentCard.vue?vue&type=script&lang=js&"
export * from "./MostContentCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports